import React from 'react';
import { Box, Button } from '@mui/material';

const RiderTabs = ({ activeTab, onChange }) => {
    return (
        <Box sx={{ 
            display: 'flex', 
            justifyContent: 'center', 
            my: 1.5, 
            mx: 2, 
            p: 0.5,
            backgroundColor: '#f0f0f0', 
            borderRadius: '12px' 
        }}>
            <Button
                disableElevation
                onClick={() => onChange('riders')}
                sx={{
                    flex: 1,
                    textTransform: 'none',
                    fontWeight: 500,
                    borderRadius: '8px',
                    color: activeTab === 'riders' ? '#fff' : '#000',
                    backgroundColor: activeTab === 'riders' ? '#000' : '#f0f0f0',
                    // boxShadow: activeTab === 'riders' ? '0px 1px 3px rgba(0,0,0,0.1)' : 'none',
                    // '&:hover': {
                    //     backgroundColor: activeTab === 'riders' ? '#FFF' : 'transparent',
                    // }
                }}
            >
                Riders
            </Button>
            <Button
                disableElevation
                onClick={() => onChange('qr')}
                sx={{
                    flex: 1,
                    textTransform: 'none',
                    fontWeight: 500,
                    borderRadius: '8px',
                    color: activeTab === 'qr' ? '#fff' : '#000',
                    backgroundColor: activeTab === 'qr' ? '#000' : '#f0f0f0',
                    // boxShadow: activeTab === 'qr' ? '0px 1px 3px rgba(0,0,0,0.1)' : 'none',
                    // '&:hover': {
                    //     backgroundColor: activeTab === 'qr' ? '#000' : 'transparent',
                    // }
                }}
            >
                QR
            </Button>
        </Box>
    );
};

export default RiderTabs;
